import { makeStyles } from "@mui/styles";
export var useLabelStyles = makeStyles(function (theme) { return ({
    labelz: {
        color: "blue",
        marginBottom: theme.spacing(4),
    },
}); });
